export default "/_next/static/images/loaders5-f07aa74c5e27bdfe84f6c3410cb82095.gif";